import $ from 'jquery';
function dropdown(elements) {
    elements.each(function(index) {

        let attrTextAlign = $(elements[index]).attr('textalign');
        let attrRounded = $(elements[index]).attr('rounded-border');

        let dropdown = $('<div />').addClass('dropdown selectDropdown');
        let textAlign = (typeof attrTextAlign !== 'undefined' && attrTextAlign !== false) ? attrTextAlign : '';
        let rounded = (typeof attrRounded !== 'undefined' && attrRounded !== false) ? attrRounded : '';

        $(this).wrap(dropdown);

        let label = $('<span />').text($(this).attr('placeholder')).insertAfter($(this)).addClass('font-bold uppercase ' + textAlign ).addClass(rounded);
        let list = $('<ul />');

        $(this).find('option').each(function() {
            list.append($('<li />').append($('<a />').text($(this).text())));
        });

        list.insertAfter($(this));

        if($(this).find('option:selected').length) {
            label.text($(this).find('option:selected').text());
            list.find('li:contains(' + $(this).find('option:selected').text() + ')').addClass('active');
            $(this).parent().addClass('filled');
        }

        if ($(this).hasClass('light')) {
            $(this).parent().addClass('light');
        }

        if ($(this).hasClass('no-border')) {
            $(this).parent().addClass('no-border');
        }

        if ($(this).hasClass('bg-transparent')) {
            $(this).parent().addClass('bg-transparent');
        }
    });

    $(document).on('click touch', '.selectDropdown ul li a', function(e) {
        e.preventDefault();
        let dropdown = $(this).parent().parent().parent();
        let active = $(this).parent().hasClass('active');
        let label = active ? dropdown.find('select').attr('placeholder') : $(this).text();

        dropdown.find('option').prop('selected', false);
        dropdown.find('ul li').removeClass('active');

        dropdown.toggleClass('filled', !active);
        dropdown.children('span').text(label);

        if(!active) {
            dropdown.find('option:contains(' + $(this).text() + ')').prop('selected', true);
            $(this).parent().addClass('active');
        }

        dropdown.removeClass('open');
    });

    $('.dropdown > span').on('click touch', function(e) {
        let self = $(this).parent();
        self.toggleClass('open');
    });

    $(document).on('click touch', function(e) {
        let dropdown = $('.dropdown');
        if(dropdown !== e.target && !dropdown.has(e.target).length) {
            dropdown.removeClass('open');
        }
    });

    return elements;
}

export { dropdown };
